export default __webpack_public_path__ + "static/media/OpenSans-Italic-VariableFont_wdth,wght.a0e19c0b.ttf";